var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuUserManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu-user-management") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-user-management"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001132,24 C18.6274602,24 24,18.6272846 24,12 C24,5.37271544 18.6274602,0 12.0001132,0 C5.37253977,0 0,5.37271544 0,12 C0,18.6272846 5.37253977,24 12.0001132,24 Z",
    id: "Fill-1",
    fill: "#009846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5000553,8 C17.886035,8 19,9.11398964 19,10.5 C19,11.8860104 17.886035,13 16.5000553,13 C15.1140756,13 14.0001106,11.8860104 14.0001106,10.5 C13.9871575,9.11398964 15.1140756,8 16.5000553,8",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,6 C10.6525424,6 12,7.34745763 12,9 C12,10.6525424 10.6525424,12 9,12 C7.34745763,12 6,10.6525424 6,9 C6,7.33474576 7.33474576,6 9,6",
    id: "Fill-5",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84090909,16.4887218 L8.84090909,21 C6.11363636,20.0977444 3.95454545,17.8721805 3,15.0330827 C4.19318182,13.6857143 7.17045455,13 8.84090909,13 C9.44318182,13 10.2045455,13.0962406 11,13.2646617 C9.13636364,14.3112782 8.84090909,15.6947368 8.84090909,16.4887218",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9587379,21 C11.631068,21 11.315534,20.9887821 11,20.9551282 L11,16.3894231 C11,14.7964744 14.5679612,14 16.3398058,14 C17.6383495,14 19.8834951,14.4375 21,15.2900641 C19.5800971,18.6217949 16.0728155,21 11.9587379,21",
    id: "Fill-9",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUserManagement);
export default __webpack_public_path__ + "static/media/menu-user-management.7f0fac45e940ba52d0f812b7ba3ede9e.svg";
export { ForwardRef as ReactComponent };